module.exports = __webpack_public_path__ + "static/contact2-01ba4407d3070d6ebcb5e6cd80950b22.png";